import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { configRefs } from '@utils/constants';
import { DAYS_TO_MS, HOURS_TO_MS } from './time.js';

const getSubjectsQuery = () => {
  return {
    queryKey: ["papi/subjects"],
    queryFn: fetchSubjects,
    staleTime: 8 * HOURS_TO_MS,
    gcTime: 7 * DAYS_TO_MS,
    meta: {
      persist: true,
      revalidateOnRefresh: true
    }
  };
};
function useSubjects() {
  return useQuery(getSubjectsQuery()).data ?? defaultSubjects;
}
async function fetchSubjects() {
  const response = await axios.get(
    `${await configRefs.apis.papi.get()}/subjects`
  );
  return response.data.map((it) => it.title).sort();
}
const defaultSubjects = [
  "Billedkunst",
  "Biologi",
  "B\xF8rnehaveklassen",
  "Dagtilbud",
  "Dansk",
  "Dansk som andetsprog",
  "Engelsk",
  "Fransk",
  "Fysik og kemi",
  "Geografi",
  "H\xE5ndv\xE6rk og design",
  "Historie",
  "Idr\xE6t",
  "Kristendomskundskab",
  "Madkundskab",
  "Matematik",
  "Musik",
  "Natur/teknologi",
  "Naturfag",
  "Religion",
  "Samfundsfag",
  "Tysk"
];

export { fetchSubjects, getSubjectsQuery, useSubjects };
//# sourceMappingURL=subjects.js.map
